import React from 'react';
import TextField, { FilledTextFieldProps, OutlinedTextFieldProps, StandardTextFieldProps, TextFieldVariants } from '@mui/material/TextField';
// import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { JSX } from 'react/jsx-runtime';

interface IDatePickersProps {
    id: string;
    label: string;
    inputFormat?: string; // Format used to display the date
    value: Date | null;
    setValue: (value: any) => void;
    obj?: any;
}

export const DatePickers: React.FC<IDatePickersProps> = ({ id, label, inputFormat, value, setValue, obj }) => {
    const handleDateChange = (newValue: Date | null): void => {
        if (obj && id) {
            setValue({ ...obj, [id]: newValue });
        } else {
            setValue(newValue);
        }
    };

    return (
        <React.Fragment>
            
        </React.Fragment>
        // <LocalizationProvider dateAdapter={AdapterDateFns}>
        //     <MuiDatePicker
        //         label={label}
        //         value={value}
        //         onChange={handleDateChange}
        //         // inputFormat={inputFormat || 'dd/MM/yyyy'}
        //         // renderInput={(params: JSX.IntrinsicAttributes & { variant?: TextFieldVariants | undefined; } & Omit<FilledTextFieldProps | OutlinedTextFieldProps | StandardTextFieldProps, 'variant'>) => <TextField {...params} size='small' id={id} />}
        //     />
        // </LocalizationProvider>
    );
};
